import api from './base'

export default {
  getAll ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/categories`)
  },
  getLastLevelItems ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/last_level_categories`)
  },
  getById ({ businessUnitId, id }) {
    return api().get(`company/business_units/${businessUnitId}/categories/${id}`)
  },
  save ({ businessUnitId, item }) {
    return api().put(`company/business_units/${businessUnitId}/categories`, item)
  },
  delete ({ businessUnitId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/categories/${id}`)
  },
  getArticles ({ businessUnitId, id }) {
    return api().get(`company/business_units/${businessUnitId}/articles?category=${id}`)
  },
  getSubcategories ({ businessUnitId, categoryId }) {
    return api().get(`company/business_units/${businessUnitId}/categories/${categoryId}/subcategories`)
  },
  deleteSubcategory ({ businessUnitId, categoryId, subcategoryId, typeId }) {
    return api().delete(`company/business_units/${businessUnitId}/categories/${categoryId}/subcategories/${subcategoryId}?type=${typeId}`)
  },
  setSubcategory ({ businessUnitId, categoryId, podskupina }) {
    return api().put(`company/business_units/${businessUnitId}/categories/${categoryId}/subcategories`, podskupina)
  },
  setSortOrder ({ businessUnitId, categoryId, subcategoryId, type, sortOrder }) {
    return api().put(`company/business_units/${businessUnitId}/categories/${categoryId}/subcategories/${subcategoryId}/sort_order?type=${type}`, { sort_order: sortOrder })
  }
}
